import {
  PlusOutlined,
  SearchOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  EyeOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  message,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Switch,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useCallback,useEffect, useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import logo from '../../Images/alux-logo.png';
import { createActivityLog } from '../../slices/activity-log';
import ImportDataModal from '../../Common/ImportDataModal';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import plantTypeService from '../../services/plant-type.service';
import { debounce } from 'lodash';
import AddEditPlantType from './AddEditPlantType';
import ManageCapabilities from './ManageCapabilities';
import ViewPlantType from './ViewPlantType';
import formatFile from '../../Images/sample-files/plant-type-format.csv';
import eventBus from '../../utils/eventBus';



function PlantTypeList() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const [orderBy, setOrderBy] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [capabilityDrawerOpen, setCapabilityDrawerOpen] = useState(false);
  const [selectedPlantType, setSelectedPlantType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const { user: currentUser } = useSelector(state => state.auth);
  const ipAddress = useSelector(state => state.ip.ipAddress);
  const [search, setSearch] = useState(
    localStorage.getItem('plant_type_search') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('plant_type_search') || '',
  );

  useEffect(() => {
    fetchPlantTypeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pagesize, search, orderBy, statusFilter]);

  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  const fetchPlantTypeList = async () => {
    setLoading(true);
    try {
      const response = await plantTypeService.getPlantTypeList(
        page,
        pagesize,
        search || undefined,
        orderBy || undefined,
        statusFilter || undefined,
      );
      if (response.data) {
        const plantTypes = response.data.results?.data || response.data.results || response.data || [];
        setData(Array.isArray(plantTypes) ? plantTypes : []);
        setTotalRecord(response.data.count || plantTypes.length || 0);
      }
    } catch (error) {
      message.error('Failed to fetch plant types');
      console.error('Error fetching plant types:', error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedAPICall = useMemo(
    () =>
      debounce(value => {
        setSearch(value);
        setPage(1);
        localStorage.setItem('plant_type_search', value);
      }, 500),
    [],
  );
  useEffect(() => {
    const handleReload = () => {
      fetchPlantTypeList();
    };

    eventBus.on('financialYear:refresh', handleReload);

    return () => {
      eventBus.off('financialYear:refresh', handleReload);
    };
    }, [fetchPlantTypeList]);
  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy('');
    setStatusFilter(null);
    setPage(1);
    localStorage.removeItem('plant_type_search');
    fetchPlantTypeList();
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1);
    setPageSize(size);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'code' && sortOrder === 'ascend') {
      sortingEnumKey = 'code';
    }
    if (sortField === 'code' && sortOrder === 'descend') {
      sortingEnumKey = '-code';
    }
    if (sortField === 'name' && sortOrder === 'ascend') {
      sortingEnumKey = 'name';
    }
    if (sortField === 'name' && sortOrder === 'descend') {
      sortingEnumKey = '-name';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }

    return sortingEnumKey;
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    if (pagination?.pageSize) setPageSize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  };

  const handleSearch = e => {
    const value = e.target.value;
    debouncedAPICall(value);
    setInputValue(value);
  };

  const handleEdit = record => {
    setSelectedPlantType(record);
    setOpen(true);
  };

  const handleView = async record => {
    try {
      setLoading(true);
      const response = await plantTypeService.getPlantTypeById(record.id);
      if (response.data) {
        const plantTypeData = response.data.data || response.data;
        setSelectedPlantType(plantTypeData);
        setViewOpen(true);
      }
    } catch (error) {
      message.error('Failed to fetch plant type details');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async id => {
    try {
      await plantTypeService.deletePlantType(id);
      message.success('Plant Type archived successfully');
      setSelectedRowKeys([]);
      fetchPlantTypeList();
     
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Failed to archive plant type';
      message.error(errorMessage);
    }
  };
  const handleBulkArchive = async () => {
    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.error('Please select at least one record to archive');
      return;
    }

    try {
      await plantTypeService.bulkArchivePlantType(selectedRowKeys);
      message.success(
        `${selectedRowKeys.length} Plant Type(s) archived successfully`,
      );
      setSelectedRowKeys([]);
      fetchPlantTypeList();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Failed to archive plant types';
      message.error(errorMessage);
    }
  };

  const handleStatusChange = async (record, checked) => {
    try {
      await plantTypeService.changePlantTypeStatus(record.id, checked ? 'Active' : 'Inactive');
      message.success(
        `Plant Type ${checked ? 'activated' : 'Inactived'} successfully`,
      );
      fetchPlantTypeList();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Failed to change status';
      message.error(errorMessage);
    }
  };

  const handleManageCapabilities = record => {
    setSelectedPlantType(record);
    setCapabilityDrawerOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedPlantType(null);
    fetchPlantTypeList();
  };

  const onCapabilityDrawerClose = () => {
    setCapabilityDrawerOpen(false);
    setSelectedPlantType(null);
    fetchPlantTypeList();
  };

  const onViewClose = () => {
    setViewOpen(false);
    setSelectedPlantType(null);
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1,
  }));

  const allColumns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      sorter: false,
      width: 80,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      sorter: true,
      width: 120,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      width: 200,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      width: 120,
      render: (status, record) => (
        <Tag
          color={status === 'Active' ? 'green' : 'red'}
          icon={
            status === 'Active' ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )
          }
        >
          {status === 'Active' ? 'Active' : 'Inactive'}
        </Tag>
      ),
    },
    // {
    //   title: 'Assigned Capabilities',
    //   dataIndex: 'capabilities',
    //   key: 'capabilities',
    //   sorter: false,
    //   width: 250,
    //   render: (capabilities, record) => {
    //     const caps = capabilities || record.capabilities || [];
    //     if (!caps || caps.length === 0) {
    //       return <Tag color="default">No capabilities</Tag>;
    //     }
    //     const capabilityList = Array.isArray(caps) ? caps : [];
    //     return (
    //       <Space wrap>
    //         {capabilityList.slice(0, 2).map(cap => {
    //           const capName = cap.name || cap.capability?.name || cap.code || 'N/A';
    //           const capId = cap.id || cap.capability_id || cap.capability?.id;
    //           return (
    //             <Tag key={capId || capName} color="blue">
    //               {capName}
    //             </Tag>
    //           );
    //         })}
    //         {capabilityList.length > 2 && (
    //           <Tag color="default">+{capabilityList.length - 2} more</Tag>
    //         )}
    //       </Space>
    //     );
    //   },
    // },
  
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      width: 150,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      sorter: true,
      width: 150,
      render: (text, record) => {
        const createdByInfo = record?.created_by_info;
        if (createdByInfo && typeof createdByInfo === 'object') {
          const firstName = createdByInfo.first_name?.replace(/[()']/g, '').trim() || '';
          const lastName = createdByInfo.last_name?.trim() || '';
          return (
            <span>
              {firstName} {lastName}
            </span>
          );
        }
        return <span>N/A</span>;
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      width: 150,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: true,
      width: 150,
      render: (text, record) => {
        const updatedByInfo = record?.updated_by_info;
        if (updatedByInfo && typeof updatedByInfo === 'object') {
          const firstName = updatedByInfo.first_name?.replace(/[()']/g, '').trim() || '';
          const lastName = updatedByInfo.last_name?.trim() || '';
          return (
            <span>
              {firstName} {lastName}
            </span>
          );
        }
        return <span>N/A</span>;
      },
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (text, record) => (
        <Space>
          <Tooltip title="View">
            <span
              onClick={() => handleView(record)}
              style={{ cursor: 'pointer' }}
            >
              <EyeOutlined style={{ fontSize: '17px' }} />
            </span>
          </Tooltip>
          {canEdit && (
            <Tooltip title="Edit">
              <span onClick={() => handleEdit(record)} style={{ cursor: 'pointer' }}>
                <EditIcon />
              </span>
            </Tooltip>
          )}
          {canEdit && (
            <Tooltip title="Manage Capabilities">
              <span
                onClick={() => handleManageCapabilities(record)}
                style={{ cursor: 'pointer' }}
              >
                <SettingOutlined />
              </span>
            </Tooltip>
          )}
          <Popconfirm
            title={`Are you sure you want to ${
              record.status === 'Active' ? 'Inactive' : 'activate'
            } this plant type?`}
            onConfirm={() => handleStatusChange(record, record.status !== 'Active')}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title={record.status === 'Active' ? 'Inactive' : 'Activate'}>
              <span style={{ cursor: 'pointer', display: 'inline-block' }}>
                <Switch
                  checked={record.status === 'Active'}
                  checkedChildren={<CheckCircleOutlined />}
                  unCheckedChildren={<CloseCircleOutlined />}
                  disabled={!canEdit}
                />
              </span>
            </Tooltip>
          </Popconfirm>
          {canDelete && (
            <Popconfirm
              title="Are you sure you want to archive this plant type?"
              onConfirm={() => handleDelete(record.id)}
              onCancel={() => message.info('Action cancelled')}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title={'Archive'}>
                <span style={{ cursor: 'pointer', display: 'inline-block' }}>
                  <Archive />
                </span>
              </Tooltip>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'code',
    'name',
    'status',
    'capabilities',
    'created_at',
    'created_by',
    'updated_at',
    'updated_by',
    'action',
  ]);

  const csvheaders = [
    { label: 'Sr. No.', key: 'SrNo' },
    { label: 'Code', key: 'code' },
    { label: 'Name', key: 'name' },
    { label: 'Status', key: 'status' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];

  const csvFilterheaders = csvheaders.filter(header =>
    checkedList.includes(header.key),
  );

  const csvData = useMemo(
    () =>
      dataSource.map(item => ({
        SrNo: item.SrNo,
        code: item.code || 'N/A',
        name: item.name || 'N/A',
        status: item.status || 'N/A',
        created_at: item.created_at
          ? dayjs(item.created_at).format('DD-MM-YYYY HH:mm')
          : 'N/A',
        created_by: item.created_by_info
          ? `${item.created_by_info.first_name?.replace(/[()']/g, '').trim() || ''} ${item.created_by_info.last_name?.trim() || ''}`.trim() || 'N/A'
          : 'N/A',
        updated_at: item.updated_at
          ? dayjs(item.updated_at).format('DD-MM-YYYY HH:mm')
          : 'N/A',
        updated_by: item.updated_by_info
          ? `${item.updated_by_info.first_name?.replace(/[()']/g, '').trim() || ''} ${item.updated_by_info.last_name?.trim() || ''}`.trim() || 'N/A'
          : 'N/A',
      })),
    [dataSource],
  );

  const handlePdfDownload = async () => {
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pdfColumns = [
      { header: 'Sr No.', dataKey: 'SrNo' },
      { header: 'Code', dataKey: 'code' },
      { header: 'Name', dataKey: 'name' },
      { header: 'Status', dataKey: 'status' },
      { header: 'Created At', dataKey: 'created_at' },
      { header: 'Created By', dataKey: 'created_by' },
      { header: 'Updated At', dataKey: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by' },
    ];

    const pdffilteredColumns = pdfColumns.filter(column =>
      checkedList.includes(column.dataKey),
    );

    const rows = dataSource.map((item, index) => ({
      SrNo: item.SrNo,
      code: item.code || 'N/A',
      name: item.name || 'N/A',
      status: item.status || 'N/A',
      created_at: item.created_at
        ? dayjs(item.created_at).format('DD-MM-YYYY HH:mm')
        : 'N/A',
      created_by: item.created_by_info
        ? `${item.created_by_info.first_name?.replace(/[()']/g, '').trim() || ''} ${item.created_by_info.last_name?.trim() || ''}`.trim() || 'N/A'
        : 'N/A',
      updated_at: item.updated_at
        ? dayjs(item.updated_at).format('DD-MM-YYYY HH:mm')
        : 'N/A',
      updated_by: item.updated_by_info
        ? `${item.updated_by_info.first_name?.replace(/[()']/g, '').trim() || ''} ${item.updated_by_info.last_name?.trim() || ''}`.trim() || 'N/A'
        : 'N/A',
    }));

    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;

    // Heading
    pdf.setFont('times', 'bold');
    pdf.setFontSize(16);
    const headingText = 'Plant Type List';
    const headingX = pageWidth / 2 - pdf.getTextWidth(headingText) / 2;
    pdf.text(headingText, headingX, 40);

    pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);

    pdf.autoTable({
      columns: pdffilteredColumns,
      body: rows,
      startY: 65,
      theme: 'grid',
      styles: {
        font: 'times',
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false,
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
      rowPageBreak: 'avoid',
      didDrawPage: data => {
        const pageNumber = pdf.internal.getCurrentPageInfo().pageNumber;
        const totalPages = pdf.internal.getNumberOfPages();

        // ✅ Footer (Date & Time left, Page Number right)
        const currentDate = dayjs().format('DD-MM-YYYY HH:mm');
        pdf.setFontSize(10);
        pdf.text(currentDate, 40, pageHeight - 20); // left footer
        pdf.text(`Page ${pageNumber} of ${totalPages}`, pageWidth - 100, pageHeight - 20); // right footer
      },
    });

    pdf.save(`plant_type_list_${dayjs().format('YYYY-MM-DD')}.pdf`);

    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Plant Type',
        ip_address: ipAddress,
        discription: 'Plant Type PDF download successfully!',
      }),
    );
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Plant Type',
        ip_address: ipAddress,
        discription: 'Plant Type Excel download successfully!',
      }),
    );
  };

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = allColumns.filter(column =>
    checkedList.includes(column.key),
  );

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="code">Code</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="name">Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            {/* <Col xs={24} md={12}>
              <Checkbox value="capabilities">Capabilities</Checkbox>
            </Col> */}
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };
  const refreshTable = useCallback(() => {
    fetchPlantTypeList();
  }, [fetchPlantTypeList]);
  const hasPermission = permission => {
    if (!currentUser?.permissions?.permissions) return false;
    const allPermissions = Object.values(
      currentUser.permissions.permissions,
    ).flat();
    return allPermissions.includes(permission);
  };

  const canView = hasPermission('view_planttype');
  const canAdd = hasPermission('add_planttype');
  const canEdit = hasPermission('change_planttype');
  const canDelete = hasPermission('delete_planttype');
  const canDownloadExcel = hasPermission('download_plant_type_excel_copy');
  const canDownloadPdf = hasPermission('download_plant_type_pdf_copy');

  if (!canView) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You don't have permission to view this page.</p>
      </div>
    );
  }

  return (
    <>
      <div className="sticyaction">
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Plant Type Master</h2>
            <div className="bredcrumbwrp">
              <Link to="/dashboard" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Plant Type Master' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space>
              {canAdd && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setSelectedPlantType(null);
                    setOpen(true);
                  }}
                >
                  Add Plant Type
                </Button>
              )}
               {canAdd && (
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  onClick={() => setImportModalOpen(true)}
                >
                  Bulk Import
                </Button>
              )}
                {selectedRowKeys.length > 0 && canDelete && (
                <Popconfirm
                  title={`Are you sure you want to archive ${selectedRowKeys.length} selected plant type(s)?`}
                  onConfirm={handleBulkArchive}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="primary" danger>
                    Bulk Archive ({selectedRowKeys.length})
                  </Button>
                </Popconfirm>
              )}
              {canDownloadExcel && (
                <Tooltip placement="top" title={'Export Excel'}>
                  <Button
                    type="primary"
                    className="iconlink"
                    style={{ width: '10px' }}
                    onClick={activityLog}
                  >
                    <CSVLink
                      filename={`plant_type_${new Date().toISOString().split('T')[0]}.csv`}
                      data={csvData}
                      className="iconlink"
                      headers={csvFilterheaders}
                    >
                      <FileExcelOutlined />
                    </CSVLink>
                  </Button>
                </Tooltip>
              )}
              {canDownloadPdf && (
                <Tooltip placement="top" title={'Export PDF'}>
                  <Button
                    type="primary"
                    className="iconlink"
                    onClick={handlePdfDownload}
                  >
                    <FilePdfOutlined />
                  </Button>
                </Tooltip>
              )}
              <Link to="/archive-plant-type-list" className="iconlink">
                <Tooltip title="Archive">
                  <Archiveicon />
                </Tooltip>
              </Link>
              <div className="gridiconswrap">
                <Tooltip placement="topLeft" title="Column Filter Options">
                  <Dropdown
                    overlay={columnMenu}
                    trigger={['click']}
                    placement="bottomRight"
                    visible={dropdownVisible}
                    onVisibleChange={setDropdownVisible}
                  >
                    <Button
                      type="primary"
                      icon={<ColumnList />}
                      onClick={e => e.preventDefault()}
                    />
                  </Dropdown>
                </Tooltip>
              </div>
            </Space>
          </Col>
        </Row>
      </div>

      <div className="formwrapper">
        <Row gutter={16} className="mb-3">
          <Col xs={24} sm={12} md={8} lg={6}>
            <Input
              placeholder="Search by code or name"
              prefix={<SearchOutlined />}
              value={inputValue}
              onChange={handleSearch}
              allowClear
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Space>
              <Button onClick={resetFilter}>Reset</Button>
              <Button
                type={statusFilter === 'Active' ? 'primary' : 'default'}
                onClick={() => {
                  setStatusFilter(
                    statusFilter === 'Active' ? null : 'Active',
                  );
                  setPage(1);
                }}
              >
                Active
              </Button>
              <Button
                type={statusFilter === 'Inactive' ? 'primary' : 'default'}
                onClick={() => {
                  setStatusFilter(
                    statusFilter === 'Inactive' ? null : 'Inactive',
                  );
                  setPage(1);
                }}
              >
                Inactive
              </Button>
            </Space>
          </Col>
        </Row>
      </div>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <div className="tablewrp">
            <Table
              rowKey="id"
              columns={filteredColumns}
              dataSource={dataSource}
              pagination={false}
              loading={loading}
              onChange={handleTableChange}
              rowSelection={canDelete ? rowSelection : null}
              scroll={{ x: 'max-content' }}
            />
          </div>
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            pageSizeOptions={['20', '50', '100']}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>

      {open && (
        <AddEditPlantType
          open={open}
          onClose={onClose}
          plantType={selectedPlantType}
        />
      )}

      {viewOpen && (
        <ViewPlantType
          open={viewOpen}
          onClose={onViewClose}
          plantType={selectedPlantType}
        />
      )}

      {capabilityDrawerOpen && selectedPlantType && (
        <ManageCapabilities
          open={capabilityDrawerOpen}
          onClose={onCapabilityDrawerClose}
          plantType={selectedPlantType}
        />
      )}
         <ImportDataModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        refreshTable={refreshTable}
        formatFilePath={formatFile}
        model="plant-type"
      />
    </>
    
  );
}

export default PlantTypeList;

